import { render } from "./TabItem2.vue?vue&type=template&id=0f517ae4&scoped=true"
import script from "./TabItem2.vue?vue&type=script&lang=js"
export * from "./TabItem2.vue?vue&type=script&lang=js"

import "./TabItem2.vue?vue&type=style&index=0&id=0f517ae4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f517ae4"]])

export default __exports__